module.exports = __webpack_public_path__ + "media/bowls/full-bowl--white-fill-f7157dec.svg";